export default __webpack_public_path__ + "static/media/Mesh-Grad.82cdc2bd.png";